{
  "areas": [
    {
      "area-id": 0,
      "area-name": "未設定",
      "area-short-name": "未",
      "area-eng-name": "unknown"
    },
    {
      "area-id": 1,
      "area-name": "神戸",
      "area-short-name": "神",
      "area-eng-name": "kobe"
    },
    {
      "area-id": 2,
      "area-name": "阪神",
      "area-short-name": "阪",
      "area-eng-name": "hanshin"
    },
    {
      "area-id": 3,
      "area-name": "丹波",
      "area-short-name": "丹",
      "area-eng-name": "tanba"
    },
    {
      "area-id": 4,
      "area-name": "但馬",
      "area-short-name": "但",
      "area-eng-name": "tajima"
    },
    {
      "area-id": 5,
      "area-name": "西播",
      "area-short-name": "西",
      "area-eng-name": "seiban"
    },
    {
      "area-id": 6,
      "area-name": "東播",
      "area-short-name": "東",
      "area-eng-name": "touban"
    },
    {
      "area-id": 7,
      "area-name": "淡路",
      "area-short-name": "淡",
      "area-eng-name": "awaji"
    },
    {
      "area-id": 8,
      "area-name": "県外",
      "area-short-name": "他",
      "area-eng-name": "kengai"
    }
  ]
}
